import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';
import { WavyLink } from "react-wavy-transitions";

import Portafolio from '../Components/Portafolio';
import Waves from './Images/Waves';
import Services from './Images/Services';
import IndexImg from './Images/Index';

import idx2 from '../Images/Index/2.png';

import idx4 from '../Images/index-1.png';
import idx5 from '../Images/index-2.png';
import idx6 from '../Images/index-3.png';
import idx7 from '../Images/tarjetas.png';
import idx8 from '../Images/wa.png';
import idx9 from '../Images/mail.png';

import Efectos from '../Components/Efectos';
import ServicesMovil from '../Views/Images/ServicesMovil';
import ServicesTablet from '../Views/Images/ServicesTablet';
import Formulario from '../Components/Formulario';

import { useAuth } from '../Context/Context';


const Index = props => {
  const { direction, cambio } = useAuth();
    
  useEffect(() => {
    var elems = document.querySelectorAll('.sidenav');
    M.Sidenav.init(elems);
  }, []);


    return (
      <Fragment>

        <div className="flexbox contendor-grd">
          <div className='flexbox-hijo order-1'>
            <p className='titulo_nv_1 centrar-texto' style={{marginBottom:"0px"}}>
              Que el primer paso <br />
              sea <span style={{color:"#A741AF", fontFamily:"Gotham-Regular"}}> la creatividad.</span> 
            </p>
            <p className='sub_titulo_nv_1 centrar-texto' style={{marginTop:"10px"}}>
              Creemos en el poder de la tecnología <br />
              y en la fuerza para hacer crecer cada negocio.
            </p>
            <div className='center-btn' style={{marginBottom:"20px"}}>
              <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                <p class="boton btn-principal z-depth-4" onClick={cambio} style={{width:"270px", margin:"0px"}}>
                  Empecemos tu proyecto
                </p>
              </WavyLink>
              {/* <a class="boton btn-principal z-depth-4" href='/contacto' style={{width:"270px"}}>Empecemos tu proyecto</a> */}
            </div>
          </div>
          <div className='flexbox-hijo center-image order-2 contenedor-tablet'>
            <IndexImg />
          </div>
        </div>

        {window.screen.width <= 550 && (
          <ServicesMovil/>
        )}
        {window.screen.width >= 551 && window.screen.width <= 992 && (
          <ServicesTablet/>
        )}
        {window.screen.width >= 993 && (
          <Services/>
        )}

        <Waves/>
        <div style={{background:"#F8F8F8"}}>
          <div className="flexbox separacion" style={{background:"#F8F8F8", marginTop:"0px"}}>

            <div className='flexbox-hijo center-image order-1'>
              <Efectos>
                <img className="dimensionar-imagen scroll-element js-scroll slide-left"  alt="Celulares" src={idx2}></img>
              </Efectos>
            </div>

            <div className='flexbox-hijo order-2 padding_right_1 contenedor-tablet'>

              <p className='sub_titulo_nv_2 centrar-texto' style={{marginBottom:"0px"}}>En nuestras páginas web</p>

              <p className='texto centrar-texto' style={{marginTop:"0px"}}>
                usamos las más novedosas tecnologías y lenguajes de programación que existen en el mercado, 
                enfocándonos en la optimización y mejora de experiencia de usuario.
              </p>

              <div className='imagen_flex_index'>
                <img alt="Sitio Web Responsivo" src={idx4}></img>
                <div>
                  <p className='sub_titulo_nv_3 centrar-texto' style={{margin:"0px", padding:"0 20px"}}>
                    Sitio web responsivo
                  </p>
                  <p className='centrar-texto' style={{margin:"0px", padding:"0 20px"}}>
                    Visualización de tu página en celulares, tabletas y computadoras, 
                    lo que nos garantiza una gran experiencia.
                  </p>
                </div>
              </div>

              <div className='imagen_flex_index' style={{margin:"15px 0px"}}>
                <img alt="Certificado SSL" src={idx5}></img>
                <div>
                  <p className='sub_titulo_nv_3 centrar-texto' style={{margin:"0px", padding:"0 20px"}}>
                    Certificado SSL
                  </p>
                  <p className='centrar-texto' style={{margin:"0px", padding:"0 20px"}}>
                    Protegemos todos los datos que se recaben en tu sitio, gracias al gran protocolo de seguridad.
                  </p>
                </div>
              </div>

              <div className='imagen_flex_index'>
                <img alt="Diseño Personalizado" src={idx6}></img>
                <div>
                  <p className='sub_titulo_nv_3 centrar-texto' style={{margin:"0px", padding:"0 20px"}}>
                    Diseño personalizado
                  </p>
                  <p className='centrar-texto' style={{margin:"0px", padding:"0 20px"}}>
                    Nada de plantillas prediseñadas, nosotros creamos el diseño desde cero para 
                    ofrecerte un sitio 100% original.
                  </p>
                </div>
              </div>

              <div className='center-btn' style={{marginTop:"30px"}}>
                <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                  <p class="boton btn-cotiza z-depth-4" onClick={cambio} style={{width:"145%", margin:"0px"}}>
                    Cotiza tu proyecto 
                  </p>
                </WavyLink>
                {/* <a class="boton btn-cotiza z-depth-4" href='/contacto'> Cotiza tu proyecto </a>     */}
              </div>
            </div>
          </div>

          <div className='container' style={{marginTop:"30px"}}>
            <div class="contenedor_video">
              <iframe
                title="Somos Software Over"
                className='video'
                src="https://www.youtube.com/embed/Iu3rEdMjluE?modestbranding=1&rel=0&fs=0"
              ></iframe>
            </div>
          </div>

          <Portafolio/>

          {window.screen.width <= 550 ? (
            <div className='container' style={{marginTop:"30px"}}>
              <p className='sub_titulo_nv_5' style={{textAlign:"center", color:"#6D1867"}}>¿Qué nos hace diferentes?</p>
              <p style={{textAlign:"center"}}>
                Somos la combinación perfecta entre 
                <span style={{fontWeight:"bold"}}> gran calidad </span>
                y <span style={{fontWeight:"bold"}}>precio accesible</span>, 
                obteniendo productos totalmente personalizados.
              </p>
              <p style={{textAlign:"center", margin:"0", paddingBottom:"20px"}}>
                Incrementamos la productividad de tu negocio con 
                productos digitales, diseñados exclusivamente para cubrir tus necesidades.
              </p>
            </div>
          ) : (
            <div className='container' style={{marginTop:"30px"}}>
              <p className='sub_titulo_nv_5' style={{textAlign:"center", color:"#6D1867"}}>¿Qué nos hace diferentes?</p>
              <p style={{textAlign:"center"}}>
                Somos la combinación perfecta entre 
                <span style={{fontWeight:"bold"}}> gran calidad </span>
                y <span style={{fontWeight:"bold"}}>precio accesible</span>, <br/>
                obteniendo productos totalmente personalizados.
              </p>
              <p style={{textAlign:"center", margin:"0", paddingBottom:"20px"}}>
                Incrementamos la productividad de tu negocio con 
                productos digitales, <br />
                diseñados exclusivamente para cubrir tus necesidades.
              </p>
            </div>
          )}

        </div>

        <div className='margin-bottom-1' style={{background:"#f8f8f8"}}>
          <Efectos>
            <div className='contendor-index-imagen'>
              <img className="center-img dimensionar-imagen scroll-element js-scroll fade-in-bottom" alt="" src={idx7}></img>
            </div>
          </Efectos>
        </div>

        <div className='padding-top-1' style={{backgroundColor:"#101014"}}>
          <div className='row' style={{marginBottom:"0"}}>
            <div className='col l2 none-mobil' style={{height:"100vh"}}>
            </div>
            <div className='col s12 m12 l8'>
              <br></br>
              <p className='sub_titulo_nv_4' style={{textAlign:"center", color:"#ffffff", marginBottom:"0"}}>Instalaciones</p>
              <p className='sub_titulo_nv_5' style={{textAlign:"center", color:"#B5FCFD", marginTop:"0"}}>¡Visítanos!</p>

              <p style={{textAlign:"center", color:"#ffffff"}}>
                Te esperamos en Anillo Periférico Pte. 10003 - Interior 8 y 9, <br />
                Industrial El Colli, 45069 Zapopan, Jal
              </p>

              <div className='container'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3733.3103226279127!2d-103.44993708255615!3d20.656950199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428af637e6bd6c3%3A0x516c20566411c4d9!2sSoftware%20Over!5e0!3m2!1ses-419!2smx!4v1662573356094!5m2!1ses-419!2smx"
                style={{border:"0px", width:"100%", height:"450px", borderRadius:"25px"}} allowfullscreen="" title="mapa software over" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>

              <p className='sub_titulo_nv_5' style={{textAlign:"center", color:"#ffffff", marginBottom:"5px"}}>¡Empecemos!</p>
              <p style={{textAlign:"center", color:"#ffffff", marginTop:"0px"}}>
                Si tiene alguna duda, escribenos, <br/>
                <span style={{fontWeight:"bold"}}>
                  estaremos muy felices de ayudar.
                </span>
              </p>

              
              <div className='flexbox-boton'>

                <div className='center-btn separacion-botones'>
                  <a target="_blank" rel="noopener noreferrer" class="btn btn-formulario-1" href='https://wa.me/523333702640?text=¡Hola buen día! ¿Me podrías dar información?'> 
                    <img src={idx8} alt="Logo WhatsApp" style={{width:"36px", height:"36px"}}></img> 
                    <p style={{margin:"0px", paddingLeft:"10px", fontWeight:"bold"}}>WhatsApp</p> 
                  </a>    
                </div>
                <div className='center-btn'>
                  <a target="_blank" rel="noopener noreferrer" class="btn btn-formulario-2" href='mailto:softwareover@gmail.com?Subject=¡Hola buen día! &body=¡Hola buen día!%0E¿Me podrías dar más información?'> 
                    <img src={idx9} alt="Logo Email" style={{width:"36px", height:"36px"}}></img>
                    <p style={{margin:"0px", paddingLeft:"10px", fontWeight:"bold"}}>Email</p> 
                  </a>    
                </div>
                
              </div>

              <p style={{textAlign:"center", color:"#ffffff"}}>
                O déjanos tus datos para ponernos <br/>
                <span style={{fontWeight:"bold"}}>
                  en contacto contigo.
                </span>
              </p>

              <Formulario />

            </div>
            <div className='col l2 none-mobil'>
            </div>
          </div>
        </div>
      </Fragment>
    );
}

export default Index;
